import React from 'react'

import {Props} from './types'

const Arrow: React.FC<Props> = props => (
  <svg fill="none" height="8" viewBox="0 0 29 8" width="29" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M28.3536 4.35356C28.5488 4.15829 28.5488 3.84171 28.3536 3.64645L25.1716 0.464468C24.9763 0.269206 24.6597 0.269206 24.4645 0.464468C24.2692 0.65973 24.2692 0.976313 24.4645 1.17158L27.2929 4L24.4645 6.82843C24.2692 7.02369 24.2692 7.34027 24.4645 7.53554C24.6597 7.7308 24.9763 7.7308 25.1716 7.53554L28.3536 4.35356ZM-4.37114e-08 4.5L28 4.5L28 3.5L4.37114e-08 3.5L-4.37114e-08 4.5Z"
      fill="#D9D8D5"
    />
  </svg>
)

export default Arrow
